class SwiftypeSearchConnector {
  constructor({ engineKey }) {
    this.engineKey = engineKey
    this.baseUrl = 'https://api.swiftype.com/api/v1/public/engines'
  }

  async performSearch(searchTerm, searchOptions) {
    const params = new URLSearchParams({
      q: searchTerm,
      ...searchOptions,
    })

    const response = await fetch(`${this.baseUrl}/suggest.json?engine_key=${this.engineKey}&${params.toString()}`, {
      method: 'GET',
    })

    const jsonResponse = await response.json()
    if (jsonResponse.records && jsonResponse.records.page) {
      const hits = jsonResponse.records.page.map(item => ({
        id: item.id,
        images: [{ imageType: 'PPMB', _filepath: JSON.parse(item.customImage || '{}')?._renditions?.['300x400'] || '' }],
        permalink: item?.url,
      }))

      return {
        hits,
        estimatedTotalHits: jsonResponse.info?.page?.total_result_count || 0,
        limit: jsonResponse.info?.page?.num_results || 20,
      }
    }
    return { hits: [], estimatedTotalHits: 0, limit: 20 }
  }

  async onSearch(state, queryConfig) {
    const { searchTerm, resultsPerPage, current } = state
    if (!searchTerm) {
      return {
        results: [],
        totalPages: 0,
        totalResults: 0,
      }
    }
    const { facets, ...rest } = queryConfig

    const searchParams = {
      ...rest,
      per_page: resultsPerPage,
      page: current,
    }

    if (facets) {
      searchParams.filters = Object.keys(facets)
    }

    const response = await this.performSearch(searchTerm, searchParams)

    return {
      results: response.hits,
      totalPages: Math.ceil(response.estimatedTotalHits / resultsPerPage),
      totalResults: response.estimatedTotalHits,
    }
  }
}

export default SwiftypeSearchConnector
